export const NO_BREAK_SPACE = '\u00A0';
export const MINUS_SIGN = '\u2212';
export const EM_DASH = '\u2014';

// For special MICR font on the bank checks
export const MICR_TRANSIT = '\u0061';
export const MICR_ON_US = '\u0043';
